module.exports = __webpack_public_path__ + "static/img/015.954b95c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/015.png
// module id = WOp0
// module chunks = 0